import { render, staticRenderFns } from "./SponsorsMarquee.vue?vue&type=template&id=57ee99e7&scoped=true&"
import script from "./SponsorsMarquee.vue?vue&type=script&lang=js&"
export * from "./SponsorsMarquee.vue?vue&type=script&lang=js&"
import style0 from "./SponsorsMarquee.vue?vue&type=style&index=0&id=57ee99e7&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57ee99e7",
  null
  
)

export default component.exports